import flatpickr from "flatpickr";

const legacyJQuery = () => window.jQuery || window.$;

const globalFlatpickr = () => {
  if (typeof window.flatpickr === "function") return window.flatpickr;
  return flatpickr;
};

/** True when a flatpickr implementation is available (Sprockets or npm). */
export function isLegacyFlatpickrReady() {
  const $ = legacyJQuery();
  if ($ && typeof $.fn.flatpickr === "function") return true;
  return typeof globalFlatpickr() === "function";
}

/**
 * Initialize flatpickr on a selector. Prefers the Sprockets jQuery plugin so
 * behaviour matches vendor/_flatpickr.scss; falls back to the global/npm API.
 */
export function initFlatpickrOnSelector(selector, options) {
  const $ = legacyJQuery();
  if ($ && typeof $.fn.flatpickr === "function") {
    const $el = $(selector);
    if (!$el.length) return null;

    const element = $el.get(0);
    if (element && element._flatpickr) {
      element._flatpickr.destroy();
    }

    return $el.flatpickr(options);
  }

  const fp = globalFlatpickr();
  if (typeof fp !== "function") return null;

  const element =
    typeof selector === "string" ? document.querySelector(selector) : selector;
  if (!element) return null;

  if (element._flatpickr) {
    element._flatpickr.destroy();
  }

  return fp(element, options);
}

export function parseFlatpickrDate(dateStr, format = "Y-m-d") {
  if (!dateStr) return null;

  const fp = globalFlatpickr();
  if (fp && typeof fp.parseDate === "function") {
    return fp.parseDate(dateStr, format);
  }

  return null;
}

export default flatpickr;
